function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5 15C11.567 15 10 13.433 10 11.5C10 9.567 11.567 8 13.5 8C15.433 8 17 9.567 17 11.5C17 13.433 15.433 15 13.5 15ZM19.742 10.875H21.0545C21.7794 10.875 22.367 11.4626 22.367 12.1875C22.367 12.9124 21.7794 13.5 21.0545 13.5H19.742C19.0171 13.5 18.4295 12.9124 18.4295 12.1875C18.4295 11.4626 19.0171 10.875 19.742 10.875ZM16.7326 6.82491L17.6606 5.89683C18.1732 5.38426 19.0042 5.38426 19.5168 5.89683C20.0294 6.40939 20.0294 7.24042 19.5168 7.75298L18.5887 8.68106C18.0762 9.19362 17.2451 9.19362 16.7326 8.68106C16.22 8.1685 16.22 7.33747 16.7326 6.82491ZM13.1795 3C13.9044 3 14.492 3.58763 14.492 4.3125V5.625C14.492 6.34987 13.9044 6.9375 13.1795 6.9375C12.4546 6.9375 11.867 6.34987 11.867 5.625V4.3125C11.867 3.58763 12.4546 3 13.1795 3ZM6.88882 5.89683C7.40138 5.38426 8.23241 5.38426 8.74497 5.89683L9.67305 6.82491C10.1856 7.33747 10.1856 8.1685 9.67305 8.68106C9.16049 9.19362 8.32946 9.19362 7.81689 8.68106L6.88882 7.75298C6.37625 7.24042 6.37625 6.40939 6.88882 5.89683Z",
  fill: "#F2994A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.74715 20.0426C3.0941 18.974 2 17.1148 2 15C2 11.6863 4.68629 9 8 9C10.7958 9 13.1449 10.9122 13.811 13.5H16.25C18.3211 13.5 20 15.1789 20 17.25C20 19.3211 18.3211 21 16.25 21H7.25C6.28818 21 5.41093 20.6379 4.74715 20.0426Z",
  fill: "#F2994A"
});

var SvgDay = function SvgDay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/day.cc89e5f0.svg";
export { ForwardRef as ReactComponent };